import React from 'react';
import { FILTER_CONFIGS, PRODUCT_CATEGORIES } from '../services/openaiService';
import './Filters.css';

const Filters = ({ activeTab, filters, onFilterChange, selectedCategory, onCategoryChange }) => {
  const config = FILTER_CONFIGS[activeTab] || {};

  const handleChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  return (
    <div className="filters-bar">
      {/* Category dropdown only for Products tab */}
      {activeTab === 'products' && (
        <div className="filter-item filter-category">
          <label>Category</label>
          <select
            value={selectedCategory}
            onChange={(e) => onCategoryChange(e.target.value)}
            className="filter-select"
          >
            <option value="">All Categories</option>
            {PRODUCT_CATEGORIES.map((cat) => (
              <option key={cat.value} value={cat.value}>
                {cat.label}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Dynamic filters based on tab */}
      {Object.entries(config).map(([key, field]) => (
        <div key={key} className="filter-item">
          <label>{field.label}</label>
          {field.type === 'select' ? (
            <select
              value={filters[key] || ''}
              onChange={(e) => handleChange(key, e.target.value)}
              className="filter-select"
            >
              {field.options.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          ) : field.type === 'toggle' ? (
            <label className="toggle-switch">
              <input
                type="checkbox"
                checked={!!filters[key]}
                onChange={(e) => handleChange(key, e.target.checked)}
              />
              <span className="toggle-slider"></span>
              <span className="toggle-label-text">
                {filters[key] ? 'Yes' : 'No'}
              </span>
            </label>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default Filters;
